import ExternalApiRequest from "./../utils/ExternalApiRequest";
import actionTypes from "./../constants/actionTypes";
import { getList, getListFormJson } from "./formActions";
import { toast } from 'react-toastify';
import { cleanObject } from "../utils/utility";

export const listTags = (requestPayload, listFormKey) => {
    try {
        return async (dispatch, getState) => {
            const formData = await getListFormJson(listFormKey);
            const listResponse = await getList(requestPayload, "listDocuments", "documents");
            const listJson = formListJson(formData, listResponse);
            return dispatch({
                type: actionTypes.TAGS.LIST_TAGS,
                payload: listJson,
            });
        }
    } catch (error) {
        console.log(error);
    }
}

const formListJson = (formPayload, listPayload) => {
    const { data = {}, meta = {} } = formPayload;
    const { documents = [], meta: listMeta = {} } = listPayload;
    const { section = [] } = data;
    const [firstSection = {}] = section;
    const { fields = [] } = firstSection;
    const listData = documents.map(doc => {
        const { data = {}, key = '' } = doc;
        const { description = '' } = data;
        const rowData = fields.reduce((accum, field, index) => {
            let value = '';
            switch (field.id) {
                case "description": {
                    value = description;
                    break;
                }
                case "action": {
                    value = ["edit", "copy"];
                    break;
                }
                default: value = doc[field.id] || '';
            }
            return { ...accum, [field.id]: value };
        }, {});
        return rowData;
    });
    return { headers: fields, data: listData, meta };
}

export const saveTag = (requestPayload) => {
    try {
        return async (dispatch, getState) => {
            const options = {
                api: "saveDocuments",
                content: cleanObject(requestPayload, [null, ""])
            };
            const response = await ExternalApiRequest(options);
            return dispatch({
                type: actionTypes.TAGS.SAVE_TRACKING,
                payload: response,
            });
        }
    } catch (error) {
        console.log(error);
    }
}

export const emptySaveResponse = () => {
    try {
        return async (dispatch) => {
            return dispatch({
                type: actionTypes.TAGS.SAVE_TRACKING,
                payload: {},
            });
        }
    } catch (error) {
        console.log(error);
    }
}

export const emptyListing = () => {
    try {
        return async (dispatch) => {
            return dispatch({
                type: actionTypes.TAGS.LIST_TAGS,
                payload: {},
            });
        }
    } catch (error) {
        console.log(error);
    }
}

export const getTag = (content) => {
    try {
        return async (dispatch) => {
            const options = {
                api: "listDocuments",
                content: content
            };
            const response = await ExternalApiRequest(options);
            const { payload = {}, status = {} } = response;
            const { documents = [] } = payload;
            const [doc = {}] = documents;
            return dispatch({
                type: actionTypes.TAGS.GET_TRACKING,
                payload: doc,
            });
        }
    } catch (error) {
        console.log(error);
    }
}

export const emptyGetTag = () => {
    try {
        return async (dispatch) => {
            return dispatch({
                type: actionTypes.TAGS.GET_TRACKING,
                payload: {},
            });
        }
    } catch (error) {
        console.log(error);
    }
}